import React from 'react'
import * as Grid from '../../Grid'

import Service from './components/Service'

import { Container, ImgContainer, Img, Card } from './style'

import words from '../../../images/home/logos.png'
import duties from '../../../images/home/duties.svg'
import checkpoint from '../../../images/home/checkpoint.svg'
import returns from '../../../images/home/returns.svg'
import sticker from '../../../images/home/sticker.svg'

function ServiceContainer() {
  return (
    <Grid.Container>
      <Grid.Row>
        <Grid.Column md={12}>
          <Container>
            <Card>
              <Service
                img={sticker}
                title="Label"
                detail="Create the destination country's final mile label from anywere."
              />
              <Service
                img={checkpoint}
                title="Management"
                detail="We will help you with the management and duties recollection."
              />
              <Service
                img={returns}
                title="Tracking"
                detail="Track your shipment using any number associated."
              />
              <Service
                img={duties}
                title="Documentation"
                detail="We will provide all the documentation needed through our API."
              />
            </Card>
            <ImgContainer>
              <Img src={words} />
            </ImgContainer>
          </Container>
        </Grid.Column>
      </Grid.Row>
    </Grid.Container>
  )
}

export default ServiceContainer
